import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let board_id = useDataValue({
    context: 'selected',
    path: 'board_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      board_id,
    },
    pause: !board_id,
    requestPolicy: 'cache-and-network',
  }
}
